export const environment = {
  adultAge: 18,
  production: false,
  host: 'https://cube.ayntap.com/api',
  uploadHostUrl: 'https://cube.ayntap.com/api',
  uploaderFilesBaseUrl: 'https://cube.ayntap.com/images',
  extensionHost: 'https://cube.ayntap.com/api',
  storageServerUrl: 'https://cube.ayntap.com',
  socketUrl: 'wss://cube.ayntap.com/ws',
  appTitle: 'Cube',
  portalUrl: 'https://cube.ayntap.com/trading',
  priceMultiplicator: 10000000000,
  quantityMultiplicator: 1000000,
  reCaptchaSiteKey: '6LddvvUUAAAAAHs1xywjlby6dgF6PWVaUUMpJSdb',
  version: '1.0.0',
  beErrorLangKey: 'BACKEND_ERRORS',
  maxUploadSizeInMB: 3,
  unavailableCountries: ['US'],
  cookie: {
    secure: true,
    domain: 'cube-admin.ayntap.com',
  },
  firebase: {
    apiKey: 'AIzaSyA38WyespLkjduPzE733fT0ekFM6HNkLjE',
    authDomain: 'testexchangepush.firebaseapp.com',
    databaseURL: 'https://testexchangepush.firebaseio.com',
    projectId: 'testexchangepush',
    storageBucket: 'testexchangepush.appspot.com',
    messagingSenderId: '472555660346',
    appId: '1:472555660346:web:eb8783c9e59c8e67720103',
    measurementId: 'G-EXG88WK1N1',
  },
};
